import { createOAuthRouter } from "@masteryprep/authprovider"
import { getEnv } from "../../../../utils/env"
import { store } from "../../../mp-core/redux/store"
import { firebaseauth, firebaseAuth } from "../../../mp-database"
import { authingUserSuccess } from "../../../mp-core/redux/modules/users"
import { logLogin } from "../../../mp-client/Auth"
import { MpLoader } from "../../../mp-shared-components/ready-shared-components/components/mpLoader"
import {
  EventCategory as EVC,
  EventAction as EVA,
  EventLabel as EVL
} from "../../../mp-utils/generic-utils/Events/types"
import {
  generateEventMetadata,
  faLogEvent
} from "../../../mp-utils/generic-utils/Events/helpers"
import {
  trackEvent,
  trackSessionStart
} from "../../../mp-utils/generic-utils/Events/eventService"

const logEventViaTrackEvent = (
  category: string,
  action: string,
  label: string,
  params: Record<string, unknown> = {}
) => {
  faLogEvent(category as EVC, action as EVA, label as EVL, params)

  trackEvent(
    {
      type: action as EVA,
      category: category as EVC,
      label: label as EVL,
      meta: params
    },
    "fa"
  )
}

export default createOAuthRouter({
  auth: {
    signOut: () => firebaseauth.signOut(),
    signInWithCustomToken: token =>
      firebaseAuth()
        .signInWithCustomToken(token)
        .then(() => {})
  },
  app: {
    id: getEnv("APPLICATION_ID"),
    cloudFunctionRoot: getEnv("CLOUD_FUNCTION_ROOT")
  },
  state: {
    onAuthSuccess: user => store.dispatch(authingUserSuccess(user))
  },
  analytics: {
    logLogin,
    logSessionStart: trackSessionStart,
    logEvent: logEventViaTrackEvent,
    generateEventMetadata,
    categories: {
      AUTH: EVC.AUTH,
      CLEVER: EVC.CLEVER,
      CLASSLINK: EVC.CLASSLINK
    },
    actions: { LOGIN: EVA.LOGIN },
    labels: {
      SUCCESS: EVL.SUCCESS,
      REPORTING: EVL.REPORTING,
      ERROR: EVL.ERROR,
      CLEVER: EVL.CLEVER,
      CLASSLINK: EVL.CLASSLINK
    }
  },
  components: { LoaderComponent: MpLoader }
})
